<template>
  <div class="input-block">
    <!-- 输入框input -->
    <el-input
        v-model="myValue"
        :placeholder="data.placeholder"
        :clearable="!!data.clearable"
        :show-password="!!data.showPassword"
        :disabled="!!data.disabled"
        :size="data.size "
        :prefix-icon="data.prefixIcon"
        :suffix-icon="data.suffixIcon"
        :autocomplete="!!data.autocomplete?'on':'off'"
        :readonly="!!data.readonly"
        :max="data.max"
        :min="data.min"
        :step="data.step"
        :resize="data.resize?data.resize:'none'"
        :autofocus="!!data.autofocus"
        :type="data.inputType?data.inputType : 'text'"
        :rows="data.textRow"
        @blur="data.onBlur?data.onBlur:()=>{}"
        @focus="data.onFocus?data.onFocus:()=>{}"
        @change="data.onChange?data.onChange:()=>{}"
        v-if="data.type === 'text'">
      <div slot="suffix" v-if="data.helpText">

      </div>

    </el-input>
    <!-- 数字计步器 input-number -->
    <el-input-number
        v-model="myValue"
        :min="data.min"
        :max="data.max"
        :step="data.step"
        :step-strictly="data.stepStrictly"
        :precision="data.precision"
        :size="data.size"
        :disabled="data.disabled"
        :controls="!data.controls"
        :controls-position="data.controlsPosition"
        :placeholder="data.placeholder"
        v-if="data.type === 'number'"
        @blur="data.onBlur?data.onBlur:()=>{}"
        @focus="data.onFocus?data.onFocus:()=>{}"
        @change="data.onChange?data.onChange:()=>{}"
        label="描述文字">
    </el-input-number>
    <!--                            单选框-->
    <el-radio-group
        v-model="myValue"
        :size="data.size?data.size:'medium'"
        :disabled="data.disabled"
        :text-color="data.textColor"
        :fill="data.fill"
        @change="data.onChange?data.onChange:()=>{}"
        v-if="data.type === 'radio'">
      <el-radio
          v-for="(item,index) in (data.options?data.options:[])"
          :label="item[data.optionValue?data.optionValue:'value']"
          :size="item.size?item.size:'medium'"
          :disabled="item.disabled"
          :key="index"
          :border="item.border">
        {{ item[data.optionLabel ? data.optionLabel : 'label'] }}
      </el-radio>
    </el-radio-group>
    <!--                            复选框-->
    <el-checkbox-group
        v-model="myValue"
        :size="data.size?data.size:'medium'"
        :disabled="data.disabled"
        :text-color="data.textColor"
        :min="data.min"
        :max="data.max"
        :fill="data.fill"
        @change="data.onChange?data.onChange:()=>{}"
        v-if="data.type === 'checkbox'">
      <el-checkbox
          v-for="(item,index) in (data.options?data.options:[])"
          :key="index"
          :label="item[data.optionValue?data.optionValue:'value']"
          :size="item.size?item.size:'medium'"
          :disabled="item.disabled"
          :border="item.border">
        {{ item[data.optionLabel ? data.optionLabel : 'label'] }}
      </el-checkbox>
    </el-checkbox-group>
    <!--                            下拉选择select-->
    <el-select
        v-model="myValue"
        :multiple="data.multiple"
        :disabled="data.disabled"
        :size="data.size"
        :clearable="data.clearable"
        :collapse-tags="data.collapseTags"
        :multiple-limit="data.multipleLimit"
        :placeholder="data.placeholder"
        :filterable="data.filterable"
        :allow-create="data.allowCreate"
        :filter-method="data.filterMethod"
        :remote="data.remote"
        :remote-method="data.remoteMethod"
        :reserve-keyword="data.reserveKeyword"
        :default-first-option="data.defaultFirstOption"
        :automatic-dropdown="data.automaticDropdown"
        :style="{width:data.width?data.width:'auto'}"
        @blur="data.onBlur?data.onBlur:()=>{}"
        @focus="data.onFocus?data.onFocus:()=>{}"
        @change="data.onChange?data.onChange($event):()=>{}"
        @remove-tag="data.onRemoveTag?data.onRemoveTag:()=>{}"
        v-if="data.type === 'select'">
      <div v-if="data.options[0] && data.options[0].length >= 0">
        <el-option-group
            v-for="(group,index) in data.options"
            :key="index"
            :label="group.label">
          <el-option
              v-for="(item,ii) in  group"
              :key="ii"
              :label="item[data.optionLabel?data.optionLabel:'label']"
              :disabled="item.disabled"
              :value="item[data.optionValue?data.optionValue:'value']">
          </el-option>
        </el-option-group>
      </div>
      <div v-else>
        <el-option
            v-for="(item,iii) in  (data.options?data.options:[])"
            :key="iii"
            :label="item[data.optionLabel?data.optionLabel:'label']"
            :disabled="item.disabled"
            :value="item[data.optionValue?data.optionValue:'value']">
        </el-option>
      </div>
    </el-select>
    <!--                                联机选择器-->
    <el-cascader
        v-if="data.type === 'cascader'"
        v-model="myValue"
        :props="data.props"
        :size="data.size"
        :placeholder="data.placeholder"
        :disabled="data.disabled"
        :clearable="data.clearable"
        :show-all-levels="data.showAllLevels"
        :collapse-tags="data.collapseTags"
        :separator="data.separator"
        :filterable="data.filterable"
        :filter-method="data.filterMethod"
        :debounce="data.debounce"
        :before-filter="data.beforeFilter"
        :options="data.options"
        @blur="data.onBlur?data.onBlur:()=>{}"
        @focus="data.onFocus?data.onFocus:()=>{}"
        @change="data.onChange?data.onChange:()=>{}"
        @remove-tag="data.onRemoveTag?data.onRemoveTag:()=>{}"></el-cascader>
    <!--                                Switch开关-->
    <el-switch
        v-if="data.type === 'switch'"
        v-model="myValue"
        :disabled="data.disabled"
        :width="data.width"
        :active-icon-class="data.activeIconClass"
        :inactive-icon-class="data.inactiveIconClass"
        :active-text="data.activeText"
        :inactive-text="data.inactiveText"
        :active-value="data.activeValue"
        :inactive-value="data.inactiveValue"
        :active-color="data.activeColor"
        @change="data.onChange?data.onChange:()=>{}"
        :inactive-color="data.inactiveColor">
    </el-switch>
    <!--                                滑块-->
    <el-slider
        v-if="data.type==='slider'"
        :min="data.min"
        :max="data.max"
        :disabled="data.disabled"
        :step="data.step"
        :show-stops="data.showStops"
        :show-tooltip="data.showTooltip"
        :format-tooltip="data.formatTooltip"
        :range="data.range"
        :vertical="data.vertical"
        :height="data.height"
        :marks="data.marks"
        @change="data.onChange?data.onChange:()=>{}"
        v-model="myValue">
    </el-slider>
    <!--                                时间选择-->
    <el-time-picker
        v-if="data.type === 'timePicker'"
        v-model="myValue"
        :readonly="data.readonly"
        :disabled="data.disabled"
        :editable="data.editable"
        :clearable="data.clearable"
        :size="data.size"
        :placeholder="data.placeholder"
        :start-placeholder="data.startPlaceholder"
        :end-placeholder="data.endPlaceholder"
        :is-range="data.isRange"
        :arrow-control="data.arrowControl"
        :align="data.align"
        :picker-options="data.pickerOptions"
        :range-separator="data.rangeSeparator"
        :value-format="data.valueFormat"
        @change="data.onChange?data.onChange:()=>{}"
        :style="{width:data.width?data.width:'auto'}"
        :default-value="data.defaultValue"
    >
    </el-time-picker>
    <!--                                日期选择器-->
    <el-date-picker
        v-if="data.type === 'datePicker'"
        v-model="myValue"
        :readonly="data.readonly"
        :disabled="data.disabled"
        :editable="data.editable"
        :clearable="data.clearable"
        :size="data.size"
        :placeholder="data.placeholder"
        :start-placeholder="data.startPlaceholder"
        :end-placeholder="data.endPlaceholder"
        :type="data.dateType"
        :align="data.align"
        :picker-options="data.pickerOptions"
        :range-separator="data.rangeSeparator"
        :default-value="data.defaultValue"
        :default-time="data.defaultTime"
        @change="data.onChange?data.onChange:()=>{}"
        :valueFormat="data.valueFormat"
        :style="{width:data.width?data.width:'auto'}"
        :format="data.format">
    </el-date-picker>
    <!--       TO DO  上传组件-->
    <lj-upload v-if="data.type === 'upload'" :formData="data"></lj-upload>

    <lj-tag v-if="data.type === 'tag'" :formData="data"></lj-tag>

    <el-color-picker
        v-model="myValue"
        :disabled="data.disabled"
        :size="data.size"
        :show-alpha="data.showAlpha"
        :color-format="data.colorFormat"
        v-if="data.type === 'color'">
    </el-color-picker>
  </div>
</template>

<script>
  import LjUpload from "./lj-upload";
  import LjTag from "./lj-tag";

  export default {
  name: "ljInput",
    components: {LjTag, LjUpload},
    props: ["value", "data"],
  data() {
    return {
      myValue: this.value,
    }
  },
  watch: {
    myValue(value) {
      this.$emit('input', value);
    },
    value(value) {
      this.myValue = value
    }
  },
  methods: {
    updateVal(val) {
      this.$emit('input', val);
    }
  }
}
</script>

